import React, {useContext} from 'react'
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import {Collapse} from "@material-ui/core";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";


function ContractDraftData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("advancePayment")}
            required
        />

        <Collapse in={gVal("advancePayment") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("advancePaymentInfo")}
                required
                multiline
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("contractChanges")}
            required
        />

        <Collapse in={gVal("contractChanges") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("contractChangesInfo")}
                required
                multiline
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("socialAspects")}
            required
        />

        <Collapse in={gVal("socialAspects") === true}>
            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("socialAspectsInfo")}
                items={getDict("SL.MO.022")}
                required
                multiple
            />
        </Collapse>

    </>)
}

ContractDraftData.propTypes = {};

export default ContractDraftData;
